import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsDescription = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-description", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsDescription;
